angular.module('dnecom')
    .controller('UpgradeModalController', ["$scope", "$uibModalInstance", function ($scope, $uibModalInstance) {

        $scope.doNotShowAgain = false;
        $scope.closeModal = function () {
            $uibModalInstance.dismiss();
        };

        $scope.onChange = function () {
            var key = 'cd-skip-info';
            if ($scope.doNotShowAgain) {
                localStorage.setItem(key, '1');
            } else {
                localStorage.removeItem(key);
            }
        };
    }]);
